<template>
  <div>
    <CourseProgressBar
      :percent="course.attended_percent"
      class="course-progress-bar"
    />
  </div>
</template>

<script>
  import CourseProgressBar from './CourseProgressBar'

  export default {
    components: {
      CourseProgressBar,
    },
    
    props: {
      course: { type: Object, default: () => ({}) }
    }
  }
</script>